import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';
import { css } from 'emotion';
import NavigationUtils from 'utils/NavigationUtils';
import ToolbarItem from 'components/core/toolbar/ToolbarItem';
import AbstractLocalStorageComponent from 'components/core/AbstractLocalStorageComponent';

export default class OverviewViewDropdown extends AbstractLocalStorageComponent {
    static propTypes = {
        mode: PropTypes.string.isRequired,
        processId: PropTypes.string.isRequired,
        revisionNum: PropTypes.string,
        style: PropTypes.object
    };

    onInterdependenciesClick = () => {
        NavigationUtils.gotoVariableRetrieval(this.props.processId, this.props.revisionNum);
        this.setLSState({ isOverviewTable: false });
    };

    onTableClick = () => {
        NavigationUtils.gotoVariableRetrievalSpreadsheet(this.props.processId, this.props.revisionNum);
        this.setLSState({ isOverviewTable: true });
    };

    render() {
        return (
            <ToolbarItem
                title={<span className={css`text-transform:capitalize;`}><strong>View:</strong> {this.props.mode}</span>}
                enabled
                dropdownButton
                textOnly
                style={this.props.style}
            >
                <Menu>
                    <Menu.Item
                        onClick={this.onInterdependenciesClick}
                    >
                        Interdependencies
                    </Menu.Item>
                    <Menu.Item
                        onClick={this.onTableClick}
                    >
                        Table
                    </Menu.Item>
                </Menu>
            </ToolbarItem>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/core/OverviewViewDropdown.js